import './FutureFocusCard.css';
import NamePill from '../NamePill/NamePill';
import { getImageSrc } from '../../utils/imageUtils';

export default function FutureFocusCard({
  icon,
  title,
  keypoints
}) {
  const iconBase = process.env.PUBLIC_URL || '';
  const point_icon = getImageSrc(`${iconBase}/code.svg`);
  const title_icon= getImageSrc(`${iconBase}/future_focus.svg`);

  return (
    <article className="FutureFocusCard">
      <img
        className="FutureFocusCard__TitleIcon"
        src={title_icon}
        alt=""
        aria-hidden="true"
      />
      <h3 className="FutureFocusCard__topic">{title}</h3>
      <div className="FutureFocusCard__meta">
      {keypoints.map((keypoint,index)=>(
          <div className="FutureFocusCard__metaRow">
            <span className="FutureFocusCard__metaLabel FutureFocusCard__metaLabel--city">
              <img
                className="FutureFocusCard__metaIcon"
                src={point_icon}
                alt=""
                aria-hidden="true"
              />
            </span>
            <span className="FutureFocusCard__metaValue">{keypoint}</span>
          </div>
        ))}

      </div>
    </article>
  );
}
